import React from "react";
import { useForgotPassword } from "../../hooks/useForgotPassword";
import ForgotPasswordView from "./ForgotPasswordView";

function ForgotPasswordContainer() {
    const forgotPassword = useForgotPassword();
    return <ForgotPasswordView {...forgotPassword} />;
}

export default ForgotPasswordContainer;
